export const loginIndustry = (session) => {
    return {
        type: "LOGIN_INDUSTRY_USER",
        payload: session,
    };
};
export const logoutIndustry = () => {
    return {
        type: "LOGOUT_INDUSTRY_USER",
    };
};
